import { render } from "./TurnsTaken.vue?vue&type=template&id=416b835e"
import script from "./TurnsTaken.vue?vue&type=script&lang=js"
export * from "./TurnsTaken.vue?vue&type=script&lang=js"
script.render = render

export default script